export function GhostIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="43"
      height="42"
      viewBox="0 0 43 42"
      fill="none"
    >
      <g opacity="0.28" clipPath="url(#clip0_2907_2452)">
        <path
          d="M9.60423 17.0862C9.60423 17.0862 6.8538 16.086 5.02018 12.3354C4.3534 11.1686 3.18655 10.5018 2.1864 10.8352C0.936201 11.2519 0.352776 13.0022 1.10289 14.6691C2.60313 18.003 5.6036 23.1705 10.9378 25.4208"
          fill="#DFE3E5"
        />
        <path
          opacity="0.1"
          d="M1.10223 14.586C2.51912 17.9198 5.60293 23.0873 10.9371 25.3377L10.5204 22.7539C5.26955 20.5036 2.35242 15.5028 0.935534 12.1689C0.685495 12.8357 0.685495 13.7525 1.10223 14.586Z"
          fill="#252525"
        />
        <path
          d="M35.6079 39.173C32.274 38.3395 28.9402 36.6726 26.4398 38.3395C23.9394 40.0065 21.3557 40.0065 21.3557 40.0065C21.3557 40.0065 18.8553 40.0065 16.3549 38.3395C13.8545 36.6726 10.5206 38.3395 7.18677 39.173C3.85292 40.0065 1.35252 38.3395 4.68638 34.1722C8.02024 30.0049 8.8537 22.5037 8.8537 14.1691C8.8537 7.25132 14.4379 1.66711 21.3557 1.66711C28.0234 1.66711 33.941 7.25132 33.941 14.1691C33.941 22.5037 34.7744 30.0049 38.1083 34.1722C41.4422 38.3395 38.9418 40.0065 35.6079 39.173Z"
          fill="#DFE3E5"
        />
        <path
          opacity="0.1"
          d="M35.608 39.1731C32.2742 38.3397 28.9403 36.6727 26.4399 38.3397C23.9395 40.0066 21.3558 40.0066 21.3558 40.0066C21.3558 40.0066 18.8554 40.0066 16.355 38.3397C13.8546 36.6727 10.5208 38.3397 7.1869 39.1731C4.68651 39.7566 2.68619 39.0064 3.18627 36.8394C3.60301 36.8394 4.18643 36.7561 4.68651 36.6727C8.02037 35.8393 11.3542 34.1723 13.8546 35.8393C16.355 37.5062 18.8554 37.5062 18.8554 37.5062C18.8554 37.5062 21.4391 37.5062 23.9395 35.8393C26.4399 34.1723 29.7738 35.8393 33.1076 36.6727C36.4415 37.5062 38.9419 35.8393 35.608 31.672C32.2742 27.5046 31.4407 20.0035 31.4407 11.6688C31.4407 8.91838 30.5239 6.33464 28.9403 4.25098C31.9408 6.50133 33.9411 10.0852 33.9411 14.1692C33.9411 22.5038 34.7746 30.005 38.1084 34.1723C41.4423 38.3397 38.9419 40.0066 35.608 39.1731Z"
          fill="#252525"
        />
        <path
          opacity="0.8"
          d="M21.3556 25.8377C22.7365 25.8377 23.856 24.5316 23.856 22.9205C23.856 21.3095 22.7365 20.0034 21.3556 20.0034C19.9747 20.0034 18.8552 21.3095 18.8552 22.9205C18.8552 24.5316 19.9747 25.8377 21.3556 25.8377Z"
          fill="#252525"
        />
        <path
          d="M31.2742 17.8365C31.2742 17.8365 34.7747 17.1697 37.5252 12.3356C38.1919 11.1688 39.2754 10.4187 40.2756 10.752H40.3589C41.6091 11.1688 42.1925 12.919 41.4424 14.586C39.9422 17.9198 36.9417 23.0873 31.6076 25.3377"
          fill="#DFE3E5"
        />
        <path
          opacity="0.1"
          d="M41.4422 14.5858C40.0253 17.9197 37.4416 22.3371 32.6075 24.8375L32.3574 22.5871C37.6082 20.3367 40.1086 15.4193 41.6089 12.0854C41.8589 12.8356 41.8589 13.7524 41.4422 14.5858Z"
          fill="#252525"
        />
        <path
          d="M18.3551 13.419C18.9385 14.3358 18.9385 15.6693 18.3551 16.5861C17.6884 17.6696 16.6049 18.3364 15.5213 18.3364C14.4378 18.3364 13.3543 17.6696 12.6876 16.5861C12.1041 15.6693 12.1041 14.3358 12.6876 13.419C13.4377 12.3355 14.4378 11.6687 15.5213 11.6687C16.6049 11.6687 17.6884 12.3355 18.3551 13.419Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M15.5214 16.6696C16.442 16.6696 17.1883 15.9232 17.1883 15.0026C17.1883 14.082 16.442 13.3357 15.5214 13.3357C14.6008 13.3357 13.8545 14.082 13.8545 15.0026C13.8545 15.9232 14.6008 16.6696 15.5214 16.6696Z"
          fill="#252525"
        />
        <path
          d="M30.0236 13.419C30.607 14.3358 30.607 15.6693 30.0236 16.5861C29.3568 17.6696 28.2733 18.3364 27.1898 18.3364C26.1063 18.3364 25.0228 17.6696 24.356 16.5861C23.7726 15.6693 23.7726 14.3358 24.356 13.419C25.1061 12.3355 26.1063 11.6687 27.1898 11.6687C28.2733 11.6687 29.3568 12.3355 30.0236 13.419Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M27.1899 16.6696C28.1105 16.6696 28.8568 15.9232 28.8568 15.0026C28.8568 14.082 28.1105 13.3357 27.1899 13.3357C26.2693 13.3357 25.5229 14.082 25.5229 15.0026C25.5229 15.9232 26.2693 16.6696 27.1899 16.6696Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_2907_2452">
          <rect
            width="41.6732"
            height="41.6732"
            fill="white"
            transform="translate(0.519043 0.00012207)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
